module.exports = __webpack_public_path__ + "static/media/golfOuting2018.55c29464.png";